import React from "react";
import { ResponsiveDeviceType } from "../../../../../widget/layouts/ScreenMedia";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { navigate } from "../../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../../routes/routes";
import Div from "../../../../../widget/common/ui/Div";
import { SignupAccountVerificationContextImport } from "../../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import { routeName as routeNameSignupVerification } from "../SignupAccountVerificationScreen";

const SignupAccountVerificationButtons = (props: {
  type?: number | undefined;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { verificationType, resendVerification, screenName } =
    SignupAccountVerificationContextImport();

  return (
    <Div className="text-center">
      <Div className="d-center font-size-16_17 font-gotham-book color-theme-sublabel pb-2">
        <div>
          {type === 3 ? (
            <>
              <span className="font-gotham-bold">
                {AppTranslation.text("didnt_receive_code")}
              </span>
              <span
                className="px-1"
                role="button"
                onClick={() => resendVerification()}
              >
                / {AppTranslation.text("resend")}
                {screenName === routeNameSignupVerification ? " /" : ""}
              </span>
              {screenName === routeNameSignupVerification && (
                <span
                  role="button"
                  onClick={() =>
                    navigate(appRoutes.routeNameSignupVerificationChange, {
                      replace: true,
                    })
                  }
                >
                  {verificationType === "phone"
                    ? AppTranslation.text("change_phone_number")
                    : AppTranslation.text("change_email")}
                </span>
              )}
            </>
          ) : (
            <>
              <div className="font-gotham-bold">
                {AppTranslation.text("didnt_receive_code")}?
              </div>
              <div className="d-center">
                <span
                  className="px-1"
                  role="button"
                  onClick={() => resendVerification()}
                >
                  {AppTranslation.text("resend")}
                </span>
              </div>

              {screenName === routeNameSignupVerification && (
                <div className="d-center">
                  <span
                    role="button"
                    onClick={() =>
                      navigate(appRoutes.routeNameSignupVerificationChange, {
                        replace: true,
                      })
                    }
                  >
                    {verificationType === "phone"
                      ? AppTranslation.text("change_phone_number")
                      : AppTranslation.text("change_email")}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      </Div>

      {type === 3 && (
        <ButtonSingle
          handleClick={() =>
            navigate(appRoutes.routeNameLogin, { replace: true })
          }
          width={300}
          textColor="theme-sublabel"
          bgColor="trans"
          fontSize="16_17"
          fontName="book"
        >
          {AppTranslation.text("exit_without_saving")}
        </ButtonSingle>
      )}
    </Div>
  );
};

export default SignupAccountVerificationButtons;
